import { SystemState } from '../system/SystemState';

export const showDialog = (state: SystemState) => state.error.showDialog;
export const errorText = (state: SystemState) => state.error.error;
